import {isEmpty} from 'lodash';
import {Http} from '@angular/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class BusinessProfileService {
    constructor(private http:Http) {
    }

    private businessProfiles: Array<any>;

    getBusinessProfiles(): Observable<Array<any>> {
        if (isEmpty(this.businessProfiles)) {
            return this.http.get('/api/client/dictionary/business_profiles')
                .map(response => response.json())
                .map(response => {
                    this.businessProfiles = response.businessProfiles;
                    return this.businessProfiles;
                });
        } else {
            return Observable.of(this.businessProfiles);
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/api/dictionaries/business.profile.service.ts